// extracted by mini-css-extract-plugin
module.exports = {"icon_active":"_-_-pharmacy-src-input-dropdownMenu-menuHeader__icon_active--2RZlB","icon":"_-_-pharmacy-src-input-dropdownMenu-menuHeader__icon--3kPGY"};